import React, { useRef } from 'react';

import { useDetectOutsideClick } from 'hooks/useDetectOutsideClick';
import {
  RectangleDropdownButtonLeft,
  RectangleDropdownButtonRight,
  RectangleDropdownContainer,
  RectangleDropdownContent,
  RectangleDropdownOptionLabel,
  ITag,
  RectangleDropdownExpandIcon,
} from './styles';

export default function RectangleDropdownButton({ id, options = [], label, value, onChange, onClick, disabled }) {
  const dropdownRef = useRef(null);

  const [isOpenDropdown, setIsOpenDropdown] = useDetectOutsideClick(dropdownRef, false);

  return (
    <RectangleDropdownContainer ref={dropdownRef}>
      <RectangleDropdownButtonLeft id={id} small disabled={disabled} onClick={onClick}>
        {label}
      </RectangleDropdownButtonLeft>
      <RectangleDropdownButtonRight
        small
        disabled={disabled}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpenDropdown(!isOpenDropdown);
        }}
      >
        <RectangleDropdownExpandIcon isOpen={isOpenDropdown} />
      </RectangleDropdownButtonRight>
      {isOpenDropdown && (
        <RectangleDropdownContent>
          {options.map((opt, index) => (
            <RectangleDropdownOptionLabel
              key={index}
              isSelected={opt.value === value}
              onClick={() => {
                setIsOpenDropdown(!isOpenDropdown);
                onChange(opt);
              }}
            >
              <ITag isRadioIcon className={opt.value === value ? 'fa-regular fa-circle-dot' : 'fa-regular fa-circle'} />
              {opt.label}
            </RectangleDropdownOptionLabel>
          ))}
        </RectangleDropdownContent>
      )}
    </RectangleDropdownContainer>
  );
}
